/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpClient } from '@angular/common/http';
import { BULB_BUSY_COVER_SERVICE } from '../../app/angularjs.providers';
import { ResumeService } from '../resume.service';
import { Resume } from '../resume.model';

/**
 * Visual component for the pop-up modal to edit contact info for resumé.
 */
@Component({
  selector: 'bulb-resume-contact-info',
  templateUrl: './contact-info-dialog.component.html',
  standalone: false,
})
export class ResumeContactInfoDialogComponent implements OnInit {
  /**
   * User's resume reference.
   */
  public resume: any;

  /**
   * Resume contact detail object.
   */
  public resumeContactDetail: Resume = new Resume();

  /**
   * Default Constructor.
   *
   * @param bulbBusyCoverService
   * @param dialogConfig
   * @param dynamicDialogRef
   * @param resumeService
   */
  constructor(
    @Inject(BULB_BUSY_COVER_SERVICE) private bulbBusyCoverService,
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private resumeService: ResumeService,
    private http: HttpClient,
  ) {
  }

  /**
   * A lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * To handle any additional initialization tasks.
   */
  ngOnInit(): void {
    this.resume = this.dialogConfig.data.resume;
    this.resumeContactDetail = { ...this.resume };
  }

  /**
   * Close reference to resume contact dialog.
   *
   * @param resume object of the author
   */
  closeContactInfoDialog(resume?: Resume): void {
    this.dynamicDialogRef.close(resume);
  }

  /**
   * Update Resume on save.
   *
   * @param resumeContactInfo
   */
  handleFormSubmission(resumeContactInfo: NgForm) {
    this.resume.fullName = this.resumeContactDetail.fullName;
    this.resume.emailAddress = this.resumeContactDetail.emailAddress;
    this.resume.phoneNumber = this.resumeContactDetail.phoneNumber;
    this.resume.location = this.resumeContactDetail.location;

    this.bulbBusyCoverService.showBusyDuring(
      this.http.put(`resumes/${this.resume.id}`, this.resume).toPromise().then((resume : Resume) => {
        this.resumeService.isResumeContactUpdated = true;
        this.closeContactInfoDialog(resume);
      }),
    );
  }
}
